import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Images from 'Constants/Images';
// import { FacebookProvider, Page } from 'react-facebook';
import { TwitterTweetEmbed, TwitterTimelineEmbed } from 'react-twitter-embed';
import WSManager from "Helpers/WsManager";
import { Header } from 'Components';
import Config from 'Config';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAccord: null
        }
    }

    toggleAccord = key => {
        this.setState({ selectedAccord: this.state.selectedAccord == key ? null : key })
    }

    downloadBrandGuide = () => {
        const url = 'https://refpredictor-2.storage.googleapis.com/upload/ReFSocial%20Logo%20DOC%201.pdf';
        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                const a = document.createElement('a');
                a.href = window.URL.createObjectURL(blob);
                a.download = 'ReFSocial_Brand_Guidelines.pdf';
                a.click();
                window.URL.revokeObjectURL(a.href);
            })
            .catch(() => window.open(url, '_blank'));
    }

    goTo = (key) => {
        if (!Config.isLOCAL) {
            if (key == "refsocial" || key == "refid") {
                Header.showComingSoonModal(key);
                return;
            }
        }

        if (WSManager.loggedIn()) {
            WSManager.goToAppUrl(key);
        } else {
            Header.LoginModalShow(key)
        }
    }


    render() {

        const { selectedAccord } = this.state;
        return (
            <React.Fragment>

                <footer className={'main-footer'}>

                    <Container className={'cmn-site-container'}>
                        <Row className={'justify-content-center '}>

                            <Col xl={12}>
                                <Row className={'justify-content-center nav-row'}>
                                    <Col xs={12} md={12} lg={2}>
                                        <div className={`mob-accord ${selectedAccord == 1 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(1)}>COMPANY & POLICIES</div>
                                            <div className={'body'}>
                                                <ul className={'foot-link1'}>
                                                    <li><a href={'/assets/ABOUT_REFSOCIAL.pdf'} target={'_blank'}>About</a></li>
                                                    <li><a >Career Opportunities</a></li>
                                                    <li><a href={'/assets/REFSOCIAL_COMMUNITY_GUIDELINES.pdf'} target={'_blank'}>Community Guideline</a></li>
                                                    {/* <li><a href={'/assets/ReFPredictorCorporateInformation.pdf'} target={'_blank'}>Corporate Information</a></li> */}
                                                    {/* <li><Link to={'/'}>Responsible Gaming</Link></li> */}
                                                    {/* <li><a href={'/assets/ReFPredictorLeague-Rules.pdf'} target={'_blank'}>Rules</a></li> */}
                                                    {/* <li><a href={'/assets/ReFPredictorFAQs.pdf'} target={'_blank'}>FAQ's</a></li> */}
                                                    <li><a href={'/assets/REFSOCIAL_TERMS_OF_SERVICE.pdf'} target={'_blank'}>Terms of Service</a></li>
                                                    <li><a href={'/assets/REFSOCIAL_PRIVACY_POLICY.pdf'} target={'_blank'}>Privacy Policy</a></li>
                                                    <li><Link to={'/contact'}>Contact/ Feedback</Link></li>
                                                </ul>
                                                <span className={'refsoc-logo'}><img src={Images.LOGO_PURPLE} className={'ref-logo'} /> REFSOCIAL</span>

                                            </div>
                                        </div>

                                    </Col>

                                    <Col xs={12} md={12} lg={2}>
                                        <div className={`mob-accord ${selectedAccord == 2 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(2)}>SERVICES</div>
                                            <div className={'body'}>
                                                <ul className={'foot-link1'}>
                                                    <li><a onClick={() => this.goTo('refid')}>ReFID</a></li>
                                                    <li><a onClick={() => this.goTo('refsocial')}>Social</a></li>
                                                    <li><a onClick={() => this.goTo('refleague')}>Gaming</a></li>
                                                    <li><a onClick={() => this.goTo('reflive')}>Scores</a></li>
                                                    <li><a onClick={() => this.goTo('refpay')}>Purse</a></li>
                                                </ul>

                                                <div className={'hdng2 '}><span >Membership</span></div>
                                                <ul className={'foot-link2'}>
                                                    <li><a >Freemium</a></li>
                                                    <li><a >Premium</a></li>
                                                    <li><a >Premium+</a></li>
                                                </ul>
                                            </div>
                                        </div>

                                    </Col>

                                    <Col xs={12} md={12} lg={2}>
                                        <div className={`mob-accord ${selectedAccord == 3 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(3)}>FOR THE FANS</div>
                                            <div className={'body'}>
                                                <ul className={'foot-link1'}>
                                                    <li><a >Connect</a></li>
                                                    <li><a >Engage</a></li>
                                                    <li><a >Reward</a></li>



                                                </ul>

                                                <div className={'hdng2 mt-2'}><span >For Brands</span></div>
                                                <ul className={'foot-link2'}>
                                                    <li><a >Consumer Engagement</a></li>
                                                    <li><a >Advertising</a></li>
                                                    <li><a >Loyalty & Rewards</a></li>
                                                </ul>

                                                <div className={'hdng2 mt-2'}><span >For Influencers & Gamers</span></div>
                                                <ul className={'foot-link2'}>
                                                    <li><a >Channels Remuneration</a></li>
                                                    <li><a >Contests Remuneration</a></li>
                                                    <li><a >Group Donations & thrifts</a></li>
                                                </ul>
                                            </div>
                                        </div>

                                    </Col>

                                    <Col xs={12} md={12} lg={3}>
                                        <div className={`mob-accord ${selectedAccord == 4 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(4)}>RECENT POSTS</div>
                                            <div className={'body'}>
                                                {/* <div className="iframe-container">
                                                    <FacebookProvider appId="441447502995003" >
                                                        <Page href="https://www.facebook.com/refpredictor/" tabs="timeline" />
                                                    </FacebookProvider>

                                                </div> */}

                                                {/* <div className="iframe-container">
                                                    <TwitterTweetEmbed
                                                        tweetId={'1421251922607157249'}
                                                    />
                                                </div> */}

                                                <div className={'coming-soon-box'}>
                                                    <img src={Images.COMING_SOON} />
                                                    <div className={'txt-cs'}>Coming Soon</div>
                                                </div>


                                            </div>
                                        </div>

                                    </Col>

                                    <Col xs={12} md={12} lg={3}>
                                        <div className={`mob-accord ${selectedAccord == 5 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(5)}>BRAND GUIDELINES</div>
                                             <div className={'body desktop-hidden'}>
                                                <div className={'coming-soon-box'}>
                                                    <div className={'txt-cs'} onClick={this.downloadBrandGuide}>ReFSocial Logo DOC.pdf</div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* <Col xs={12} md={12} lg={3} className={'desktop-hidden'}>
                                        <div className={`mob-accord ${selectedAccord == 5 ? 'open' : ''}`}>
                                            <div className={'foot-head'} onClick={() => this.toggleAccord(5)}>Downloads</div>
                                            <div className={'body'}>

                                                <ul className={'foot-link2'}>
                                                    <li><a >Mac/ PC</a></li>
                                                    <li><a >iPhone/ Android</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Col> */}
                                    {/* <Col xs={12} md={12} lg={2}>
                                        <div className={'foot-head social-head'} style={{cursor:'pointer'}} onClick={this.downloadBrandGuide}>BRAND GUIDELINES</div>
                                        <ul className={'social-ics'}>
                                            <li>
                                                <a href='https://refpredictor-2.storage.googleapis.com/upload/ReFSocial%20Logo%20DOC%201.pdf' target={'_blank'}><i className={'icon-logo-2'}></i> <span>ReFSocial</span></a>
                                            </li>
                                        </ul>
                                    </Col> */}
                                </Row>
                            </Col>

                        </Row>



                        {/* <Row className={'ft-strip justify-content-center text-center'}>
                            <Col xs={12} md={9}>© ReFSocial ALL RIGHTS RESERVED | COPYRIGHT STATEMENT & BRAND GUIDE LINES</Col>
                        </Row> */}
                    </Container>
                </footer>

            </React.Fragment>
        )
    }
}


export default Footer;
